export default "__VITE_ASSET__Sa3ucAyq__"